import { Avatar } from "@vega-core/components/Avatar/Avatar";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type UserMenuProps = {
  fullName: string;
  initials: string;
  isCollapsed: boolean;
};

export const UserMenu = ({
  fullName,
  initials,
  isCollapsed,
}: UserMenuProps) => (
  <div
    className={cnTwMerge(
      "flex items-center gap-3 bg-background/sidebar/secondary flex-1 cursor-pointer",
      isCollapsed && "justify-center",
    )}
    data-testid="sidebar-user-menu"
  >
    <span className="sr-only">{m.common_openUserMenu()}</span>
    <Avatar initials={initials} />
    {!isCollapsed && (
      <div className="hidden md:block body-base-regular text-text/sidebar/primary">
        {fullName}
      </div>
    )}
  </div>
);
